import { Button } from "@pacificoseguros/pixie/react/button";
import React, { useCallback } from "react";
import { Row } from "../../../components/layout/flex-layout";
import { SizedBox } from "../../../components/layout/sized-box";
import { SpacingBox } from "../../../components/layout/spacing-box";

export const LandingBackToTopButton = () => {
    const handleClick = useCallback(
        () =>
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            }),
        []
    );
    return (
        <SpacingBox py={30} data-testid="back-to-top-button">
            <Row justify="center">
                <SizedBox width={300}>
                    <Button
                        kind="secondary"
                        fluid
                        onClick={handleClick}
                        data-testid="back-to-top-button-elm"
                    >
                        <b>Volver al inicio</b>
                    </Button>
                </SizedBox>
            </Row>
        </SpacingBox>
    );
};
